import React from "react";
export class AbstractMenuItemComponent extends React.Component {
    componentDidUpdate(prevProps, prevState, snapshot) {
        this.props.stateChange(this.state, prevState);
    }
}
//# sourceMappingURL=AbstractMenuItemComponent.js.map